class HyalustarScentVideo extends HTMLElement {
  connectedCallback() {
    if (this.events) return;
    this.button = this.querySelector('button');
    this.video = this.querySelector('video');
    this.events = new AbortController();
    const options = { signal: this.events.signal };
    this.mobile = window.matchMedia('(max-width: 1024px)');
    const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.button.addEventListener('pointerenter', () => {
      if (hover.matches && !reduced.matches) this.start();
    }, options);
    this.button.addEventListener('pointerleave', () => { if (!this.mobile.matches) this.stop(); }, options);
    this.button.addEventListener('click', () => {
      this.manuallyPaused = Boolean(this.wanted);
      this.wanted ? this.stop() : this.start();
    }, options);
    this.button.addEventListener('blur', () => { if (!this.mobile.matches) this.stop(); }, options);
    const sync = () => {
      if (document.hidden || !this.visible) { this.stop(); return; }
      if (this.mobile.matches && !reduced.matches && !this.manuallyPaused) this.start();
      else if (!this.mobile.matches || reduced.matches) this.stop();
    };
    document.addEventListener('visibilitychange', sync, options);
    this.mobile.addEventListener('change', sync, options);
    reduced.addEventListener('change', sync, options);
    this.observer = new IntersectionObserver(([entry]) => {
      this.visible = entry.isIntersecting && entry.intersectionRatio >= .25;
      sync();
    }, { threshold: [0, .25] });
    this.observer.observe(this);
  }

  async start() {
    if (this.wanted) return;
    this.wanted = true;
    if (!this.video.getAttribute('src')) this.video.src = this.video.dataset.src;
    this.video.muted = true;
    try {
      await this.video.play();
      if (!this.wanted) {
        this.video.pause();
        this.video.currentTime = 0;
        return;
      }
      this.button.classList.add('is-playing');
      this.button.setAttribute('aria-pressed', 'true');
      this.button.setAttribute('aria-label', (document.documentElement.lang.startsWith('en') ? 'Pause fragrance video: ' : 'Ferma il video della fragranza ') + this.dataset.scentName);
    } catch {
      this.stop();
    }
  }

  stop() {
    this.wanted = false;
    this.video.pause();
    if (this.video.readyState > 0) this.video.currentTime = 0;
    this.button.classList.remove('is-playing');
    this.button.setAttribute('aria-pressed', 'false');
    this.button.setAttribute('aria-label', (document.documentElement.lang.startsWith('en') ? 'Play fragrance video: ' : 'Riproduci il video della fragranza ') + this.dataset.scentName);
  }

  disconnectedCallback() {
    this.stop();
    this.events?.abort();
    this.events = null;
    this.observer?.disconnect();
  }
}

if (!customElements.get('hyalustar-scent-video')) {
  customElements.define('hyalustar-scent-video', HyalustarScentVideo);
}
